/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDefinizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDefinizioneCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    this.domainSrvc = domainSrvc;

    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Riferimento allo spinner di ricerca cliente
     */
    this.spinnerCliente = {
      showSpinner: 0
    };

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Descrizione del prodotto recuperata dalla pratica
     */
    this.tipoProdotto = null;

    /**
     * Descrizione del prodotto recuperata dalla rotta
     */
    this.idProdotto = null;

    /**
     * Specializzazione della pratica
     */
    this.specializzazione = null;

    /**
     * Definizione della griglia dei conti corrente
     */
    this.contiGridOptions = {};

    /**
     * Altezza della griglia dei conti corrente
     */
    this.altezzaTabellaConti = 0;

    /**
     * Altezza di una riga della griglia dei conti corrente
     */
    this.altezzaRigaConto = 30;

    /**
     * Conti corrente disponibili
     */
    this.contiCorrente = null;
    this.contiCorrenteProvvisorio = null;
    this.rapportiDelegati = null;
    /**
     * NDG usato come filtro per la ricerca utilizzatore
     */
    this.ricercaNdg = null;

    /**
     * Intestazione usata come filtro per la ricerca utilizzatore
     */
    this.ricercaIntestazione = null;

    /**
     * Definizione della griglia gli utilizzatori
     */
    this.utilizzatoriGridOptions = {};

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei comuni selezionabili per l'ente rilascio
     */
    this.comuniEnteRilascio = [];

    /**
     * Elenco delle province selezionabili
     */
    this.province = [];

    /**
     * Elenco delle province selezionabili per l'ente rilascio
     */
    this.provinceEnteRilascio = [];

    /**
     * Elenco degli enti selezionabili
     */
    this.entiRilascio = [];

    /**
     * Altezza della griglia degli utilizzatori
     */
    this.altezzaTabellaUtilizzatori = 0;

    /**
     * Altezza di una riga della griglia degli utilizzatori
     */
    this.altezzaRigaUtilizzatori = 30;

    /**
     * Elenco utilizzatori recuperato da ricerca
     */
    this.utilizzatori = null;

    /**
     * Flag che indica se il paese spedizione è editabile
     */
    this.paeseSpedizioneReadOnly = true;
    
    /**
     * Lista di ndg per recuperare i CC
     */
    this.listaNdg

    this.templateSpedizioneUrl =
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.html';

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di visualizzazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaVisibile = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return true;
        default:
          return false;
      }
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione completaVisibile
     */
    this.propostaCartaDebitoIntSrvc.completaVisibile = function () {
      return false;
    };
    /**
     * Implementazione nel service della funzione rifiutaVisibile
     */
    this.propostaCartaDebitoIntSrvc.rifiutaVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return (
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
          return (
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
          );
        default:
          return false;
      }
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return (
            !self.anagraficaIncompleta &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta &&
            // se instant issue --> obbligatorio codice busta.
            (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I1' ||
              (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I2' &&
                self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta))
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
          return (
            !self.anagraficaIncompleta &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta &&
            // se instant issue --> obbligatorio codice busta.
            (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I1' ||
              (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I2' &&
                self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta))
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.LIGHT:
          return (
            !self.anagraficaIncompleta &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tae &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio
          );
        default:
          return true;
      }
    };

    /**
     * Funzione asseganta al cambio di selezione nella tabella utilizzatori
     * Assegna o rimuove l'utilizzatore
     */
    this.selezionaUtilizzatore = function (utilizzatore) {
      if (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore !== utilizzatore.entity.ndg) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore = utilizzatore.entity.ndg;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore = null;
      }
    };

    /**
     * Funzione che esegue la ricerca degli utilizzatori in base ai parametri indicati
     */
    this.ricercaUtilizzatori = function () {
      self.messaggiFctr.resetMessages();
      self.spinnerCliente.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseRicercaCliente(self.ricercaNdg, self.ricercaIntestazione)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            // Filtro gli utilizzatori per natura giuridica PRV e IND
            self.utilizzatori = response.data.filter(function (item) {
              return item.naturaGiuridica === 'PRV' || item.naturaGiuridica === 'IND';
            });

            self.utilizzatoriGridOptions = {
              enableSorting: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              enableColumnMenus: false,
              enableGrouping: false,
              enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              treeRowHeaderAlwaysVisible: false,
              useExternalPagination: false,
              paginationPageSizes: [10, 25, 50],
              paginationPageSize: 10,
              paginationCurrentPage: 1,
              enableRowSelection: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              multiSelect: false,
              enableRowHeaderSelection: false,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              columnDefs: [
                {
                  name: $scope.msg('label.definizione.utilizzatore.ndg'),
                  field: 'ndg',
                  minWidth: 100,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'ndg'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.intestazione'),
                  field: 'intestazione',
                  minWidth: 200,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'intestazione'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.codicefiscale'),
                  field: 'codiceFiscale',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'codiceFiscale'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.prospetto'),
                  field: 'prospetto',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  cellTemplate:
                    "<div class=\"ui-grid-cell-contents\">{{row.entity.prospetto === true ? 'Prospetto' : 'Cliente'}}</div>"
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.stato'),
                  field: 'statoPratica',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'stato'
                }
              ],
              data: self.utilizzatori,
              onRegisterApi: function (gridApi) {
                gridApi.grid.modifyRows(self.utilizzatoriGridOptions.data);

                // Se era già stato salvato l'utilizzatore lo recupero e lo seleziono
                if (
                  self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
                  self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
                ) {
                  angular.forEach(self.utilizzatori, function (utilizzatore, index) {
                    if (utilizzatore.ndg === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore) {
                      gridApi.selection.selectRow(self.utilizzatori[index]);
                    }
                  });
                }

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaUtilizzatore(row);
                });
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinnerCliente.showSpinner--;
        });
    };

    /**
     * Funzione assegnata alla selezione di una riga di conto corrente
     */
    this.selezionaConto = function (conto) {
      if (
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto !== conto.entity.numeroRapporto &&
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban !== conto.entity.iban
      ) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto = conto.entity.numeroRapporto;
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban = conto.entity.iban;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto = null;
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban = null;
      }
      if (
        conto.entity.idPraticaProposta &&
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto !== conto.entity.idPraticaProposta
      ) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto = conto.entity.idPraticaProposta;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto = null;
      }
    };

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.caricaContiCorrente = function (ndgList) {
      var promiseList = [];
      for (var i = 0; i < ndgList.length; i++) {
        promiseList.push(self.propostaCartaDebitoIntSrvc.promiseRecuperaContiCorrente(ndgList[i]));
      }
      self.spinner.showSpinner++;
      $q.all(promiseList)
        .then(
          function (responses) {
            self.contiCorrenteProvvisorio = [];
            for (var responsesIndex = 0; responsesIndex < responses.length; responsesIndex++) {
              if (responses[responsesIndex].data && responses[responsesIndex].data.result) {
                for (var dataIndex = 0; dataIndex < responses[responsesIndex].data.result.length; dataIndex++) {
                  self.contiCorrenteProvvisorio.push(responses[responsesIndex].data.result[dataIndex]);
                }
              }
            }
            if(self.rapportiDelegati){
              angular.forEach(self.rapportiDelegati, function (rapporto, index) {
        		self.contiCorrenteProvvisorio.push(rapporto);
              });
            }
            
            self.rapportiDelegati = [];

            self.preparaGrigliaconti();
            
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };
    
    this.ricercaRapportiDelegati = function (ndgList) {
    	self.listaNdg = [];
    	angular.forEach(ndgList, function (ndg, index) {
			   self.listaNdg.push(ndg);
        });
    	self.spinner.showSpinner++;
    	 self.propostaCartaDebitoIntSrvc
         .promiseRicercaRapportiDelegati(self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg)
         .then(
           function (response,ndgList) {
        	   self.rapportiDelegati = [];
        	   if(response && response.data && response.data.result && response.data.result.length > 0){
        		   angular.forEach(response.data.result, function (rapporto, index) {
        			   self.rapportiDelegati.push(rapporto);
                   });
        		   console.log('Rapporti delegati inseriti:  ' + self.rapportiDelegati.length);
        	   }

        	   if (self.idPratica) {
                 self.recuperaDatiAggiuntiviDefinizione(self.listaNdg);
               } else {
                 self.caricaContiCorrente(self.listaNdg);
               }
           },
           function (reason) {
             self.messaggiFctr.processaResponse(reason);
           }
         )
         .finally(function () {
           self.spinnerCliente.showSpinner--;
         });
    }
    
    this.preparaGrigliaconti = function () {
    	self.contiCorrente = [];
    	angular.forEach(self.contiCorrenteProvvisorio, function (rapporto, index) {
    		self.contiCorrente.push(rapporto);
          });
        self.altezzaTabellaConti = self.contiCorrente.length * self.altezzaRigaConto + 40;

        self.contiGridOptions = {
          enableSorting: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          enableColumnMenus: false,
          enableGrouping: false,
          multiSelect: false,
          showHeader: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          enableRowHeaderSelection: false,
          enableRowSelection: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          showGridFooter: false,
          enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableColumnResizing: true,
          columnDefs: [
            {
              displayName: $scope.msg('label.definizione.rapporto.numero'),
              field: 'numeroRapporto',
              width: '10%',
              name: 'numeroRapporto'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.iban'),
              field: 'iban',
              width: '25%',
              name: 'iban'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.descrizione'),
              field: 'descrizione',
              width: '15%',
              name: 'descrizione'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.saldocontabile'),
              cellFilter: 'number : 2',
              cellClass: 'right',
              field: 'saldo',
              width: '10%',
              name: 'saldoContabile'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.intestazione'),
              field: 'intestatario',
              width: '20%',
              name: 'intestazione'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.stato'),
              field: 'stato',
              width: '10%',
              name: 'stato'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.dataapertura'),
              field: 'dataApertura',
              cellFilter: 'date: "dd/MM/yyyy"',
              width: '10%',
              name: 'dataApertura'
            }
          ],
          data: self.contiCorrente,
          onRegisterApi: function (gridApi) {
            gridApi.grid.modifyRows(self.contiGridOptions.data);

            // Se era già stato salvato il conto corrente lo recupero e lo seleziono
            if (
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
            ) {
              angular.forEach(self.contiCorrente, function (conto, index) {
                if (
                  conto.numeroRapporto === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
                  conto.iban === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
                ) {
                  gridApi.selection.selectRow(self.contiCorrente[index]);
                }
              });
            }

            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              self.selezionaConto(row);
            });
          }
        };
    };

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     * @param ndgList Lista deli ndg da passare al recupero dei conti correnti
     */
    this.recuperaDatiAggiuntiviDefinizione = function (ndgList) {
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promiseRecuperaDatiAggiuntivi(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (response.data.result) {
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = response.data.result;
            }

            self.caricaContiCorrente(ndgList);

            if (
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
            ) {
              self.ricercaNdg = self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore;
              self.ricercaUtilizzatori();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(response);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      if (self.idPratica) {
        self.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .promiseRecuperaProdottoPerIdPratica(self.idPratica)
          .then(function (response) {
            if (response && response.data && response.data.result) {
              self.idProdotto = response.data.result.idProdottoCPT;
            }
            self.spinner.showSpinner++;
            $q.all([
              self.propostaCartaDebitoIntSrvc.promiseRecuperaDatiAggiuntivi(self.idPratica),
              self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagrafica(self.idPratica),
              self.propostaCartaDebitoIntSrvc.promiseRecuperaTipoCarta(self.idProdotto)
            ])
              .then(function (response) {
                self.trattaResponse(response);
              })
              .finally(function () {
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
              });
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.spinner.showSpinner++;
        $q.all([
          self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagraficaPic(self.propostaCartaDebitoIntSrvc.ndg),
          self.propostaCartaDebitoIntSrvc.promiseRecuperaTipoCarta(self.idProdotto)
        ])
          .then(function (response) {
            self.trattaResponse(response);
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    this.recuperaListaNdg = function () {
      self.spinner.showSpinner++;
      var ndgList = [];

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.intestatario &&
        self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
      ) {
        // Inizializzo la lista degli ndg inserendo l'ndg dell'utente attuale
        ndgList = [self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg];
      }

      if (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS) {
        if (self.idPratica) {
          self.recuperaDatiAggiuntiviDefinizione(ndgList);
        } else {
          self.caricaContiCorrente(ndgList);
        }
      } else if (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER) {
        $q.all([
          self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagraficaCoi(
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        ])
          .then(function (response) {
            if (response[0].data.result.length > 0) {
              console.log('Ndg trovati ' + response[0].data.result);
              angular.forEach(response[0].data.result, function (ndg, index) {
                ndgList.push(ndg);
              });
              console.log('Ndg inseriti ' + ndgList);
            }
            
            //Recupero i rapporti in cui sono delegato e poi faccio
            self.ricercaRapportiDelegati(ndgList);
            //Questa logica spostata dentro ricercaRapportiDelegati
            //Mi arriva la lista degli ndg per recuperare i CC
//            if (self.idPratica) {
//              self.recuperaDatiAggiuntiviDefinizione(ndgList);
//            } else {
//              self.caricaContiCorrente(ndgList);
//            }
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner = 0;
            }
          });
      }
    };

    this.trattaResponse = function (responses) {
      console.log(responses);
      // Anagrafica
      if (responses && responses.length > 0) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita = {};
        // Dati già salvati
        // Se avevo l'idPratica allora ho fatto 3 chiamate e posso prevalorizzare
        if (
          responses.length > 2 &&
          responses[0] &&
          responses[0].data &&
          !self.messaggiFctr.processaResponse(responses[0])
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi = responses[0].data.result;
          if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
          }
          self.propostaCartaDebitoIntSrvc.currentTipoCarta = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta;
        }

        // Se non avevo l'idPratica allora ho fatto due chiamate da cui recupero l'anagrafica
        // In particolare i dati anagrafici si troveranno in posizione 1 se avevo l'idPratica,
        // oppure in posizione 0 se non l'avevo
        var position = responses.length >= 3 ? 1 : 0;

        //TODO rimuovere perchè estrapolata, le logiche di selezione degli ndg è spostata a back
        //        // Le chiamate per popolare i conti correnti necessitano di sapere dalla chiamata di anagrafica se
        //        // ci sono dei conti cointestati. Tale parametro si trova in
        //        // responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione, che è un array di
        //        // dettagli di cointestazioni. I conti correnti devono essere recuperati sia per small business che per consumer
        //        // ma solo per la consumer vengono controllati i cointestati
        //        if (
        //          (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
        //            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER) &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica.intestatario &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
        //        ) {
        //          // Inizializzo la lista degli ndg inserendo l'ndg dell'utente attuale
        //          var ndgList = [self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg];
        //          // Se siamo in consumer aggiungo gli ndg dei cointestati
        //          if (
        //            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
        //            responses &&
        //            responses.length > 0 &&
        //            responses[position] &&
        //            responses[position].data &&
        //            responses[position].data.result &&
        //            responses[position].data.result.anagrafica &&
        //            responses[position].data.result.anagrafica.relazioniAnagrafiche &&
        //            responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione
        //          ) {
        //            for (var i = 0; i < responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione.length; i++) {
        //              if (
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato &&
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato
        //                  .formaCostitutiva === 'COI' &&
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato.ndg
        //              ) {
        //                ndgList.push(
        //                  responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato.ndg
        //                );
        //              }
        //            }
        //          }
        //          // Se c'è idPratica chiamo il servizio per recueperare i dati aggiuntivi di definizione
        //          // attraverso la funzione recuperaDatiAggiuntiviDefinizione (la quale richiama anche
        //          // caricaContoCorrente), altrimenti mi limito a chiamare caricaContoCorrente
        //          if (self.idPratica) {
        //            self.recuperaDatiAggiuntiviDefinizione(ndgList);
        //          } else {
        //            self.caricaContiCorrente(ndgList);
        //          }
        //        }

        // Init tipo carta
        if (
          responses &&
          responses.length > 1 &&
          responses[position + 1] &&
          responses[position + 1].data &&
          responses[position + 1].data.result &&
          responses[position + 1].data.result.length > 0
        ) {
          if (!self.propostaCartaDebitoIntSrvc.datiDefinizioneSB) {
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
              ndgUtilizzatore: null,
              numeroRapporto: null,
              iban: null,
              tipoCarta: null,
              idPraticaConto: null
            };
          }
          if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
          }
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta = responses[position + 1].data.result[0].codice;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta = responses[position + 1].data.result[0].codice;
        } else if (
          // In caso la risposta fallisca valorizzo di default questi due tipi di carte visto che questa è per
          // forza di tipo I1
          self.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT
        ) {
          {
            if (!self.propostaCartaDebitoIntSrvc.datiDefinizioneSB) {
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
                ndgUtilizzatore: null,
                numeroRapporto: null,
                iban: null,
                tipoCarta: null,
                idPraticaConto: null
              };
            }
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
            }
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta = 'I1';
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta = 'I1';
          }
        }

        // Init dei dati
        if (responses && responses[position] && responses[position].data) {
          // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
          // dei dati mancanti nell'anagrafica. Quindi imposto il flag è disabilito il bottone
          // per proseguire
          self.anagraficaIncompleta = self.messaggiFctr.processaResponse(responses[position]);
          self.datiAnagrafici =
            responses[position].data.result && responses[position].data.result.anagrafica
              ? responses[position].data.result.anagrafica
              : {
                  contatti: {},
                  documentoIdentificativo: {},
                  indirizzoPrincipale: {},
                  indirizzoSpedizione: null
                };

          self.datiAnagraficiOriginali =
            responses[position].data.result && responses[position].data.result.anagraficaOriginale
              ? responses[position].data.result.anagraficaOriginale
              : {
                  contatti: {},
                  documentoIdentificativo: {},
                  indirizzoPrincipale: {},
                  indirizzoSpedizione: null
                };

          // Prevalorizzazione ente rilascio
          // Se non è presente nei dati aggiuntivi lo prendo da anagrafica
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            ((self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) ||
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio)
          ) {
            if (self.datiAnagrafici.documentoIdentificativo) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita = { datiEnteRilascio: {} };
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio = {
                enteRilascio: null
              };
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio =
                self.datiAnagrafici.documentoIdentificativo.enteRilascioDocumento;
              console.log(
                'ente: ' +
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
              );
              // RecuperaDomini viene chiamato in sequenza dopo questa chiamata, quindi la valorizzazione
              // onChangeEnte di enteRilascio viene lasciata a recuperaDomini
            }
          }

          // Formattazione date
          if (
            self.datiAnagrafici.documentoIdentificativo &&
            self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
          ) {
            self.datiAnagrafici.documentoIdentificativo.rilascioDocumento =
              self.propostaCartaDebitoIntSrvc.millisToDate(
                self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
              );
          }
          if (
            self.datiAnagrafici.documentoIdentificativo &&
            self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
          ) {
            self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento =
              self.propostaCartaDebitoIntSrvc.millisToDate(
                self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
              );
          }

          // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
          if (
            !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia)
          ) {
            // L'indirizzo da utilizzare per la prevalorizzazione è quello del domicilio se presente, altrimenti quello di residenza
            self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
              ? self.datiAnagrafici.indirizzoCorrispondenza
              : self.datiAnagrafici.indirizzoPrincipale;

            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione = {
              via: self.indirizzoPrevalorizzazione.via,
              numero: null,
              provincia: self.indirizzoPrevalorizzazione.provincia,
              comune: {
                valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
              },
              cap: self.indirizzoPrevalorizzazione.cap,
              nazione: self.indirizzoPrevalorizzazione.nazione,
              localita: self.indirizzoPrevalorizzazione.localita
            };

            // provo a recuperare l'indirizzo ed il civico (se riesco)
            try {
              var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                self.indirizzoPrevalorizzazione.via
              );
              if (datiIndirizzoCivico) {
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via =
                  self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero = datiIndirizzoCivico.civico;
              }
            } catch (error) {}
          }
        }
      }

      if (self.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
        self.recuperaDomini();
      }
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice === '086') {
            self.provinceEnteRilascio = responses[1];
            self.provinceEnteRilascio = self.provinceEnteRilascio.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.provinceEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio = {
              codice: '**',
              descrizione: 'STATO ESTERO'
            };
            // Devo forzare la chiamata di onProvinciaChange perché non "sente" la valorizzazione
            self.onProvinciaChange();
          }
          self.tae = responses[2];
          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];

          // Riordina tae in ordine alfabetico
          self.tae.sort(function (a, b) {
            if (a.descrizione > b.descrizione) {
              return 1;
            } else if (a.descrizione === b.descrizione) {
              return 0;
            } else {
              return -1;
            }
          });

          // Se l'ente di rilascio è stato prevalorizzato allora devo aggiornarlo attraverso l'onChange
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
          ) {
            self.onEnteChange();
          }
          self.recuperaComuni(false, false);

          // Se è presente il valore provinciaRilascio, viene prevalorizzato nella select
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice !== '**'
          ) {
            self.recuperaComuni(false, true);
          }

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }

          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * Funzione chiamata al change di provincia di documento identità. Setta correttamente la provincia
     * selezionata nel service e chiama recupera comuni
     */
    this.onProvinciaChange = function () {
      for (var i = 0; i < self.province.length; i++) {
        if (
          self.province[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.descrizione =
            self.province[i].descrizione;
          break;
        }
      }
      self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio = null;
      // Seleziona di provincia come stato estero
      if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice === '**') {
        self.comuniEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio = {
          codice: '**',
          descrizione: 'STATO ESTERO'
        };
      } else {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice) {
          self.recuperaComuni(false, true);
        } else {
          self.comuniEnteRilascio = [];
        }
      }
    };

    /**
     * Funzione chiamata al change di comune di documento identità. Setta correttamente il comune
     * selezionato nel service
     */
    this.onComuneChange = function () {
      for (var i = 0; i < self.comuniEnteRilascio.length; i++) {
        if (
          self.comuniEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.descrizione =
            self.comuniEnteRilascio[i].descrizione;
          break;
        }
      }
    };

    /**
     * Funzione chiamata al change di ente di documento identità. Setta correttamente l'ente
     * selezionato nel service
     */
    this.onEnteChange = function () {
      for (var i = 0; i < self.entiRilascio.length; i++) {
        if (
          self.entiRilascio[i].enteRilascio ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id =
            self.entiRilascio[i].id;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento =
            self.entiRilascio[i].tipoDocumento;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi =
            self.entiRilascio[i].codiceEnteNexi;
          break;
        }
      }
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori, isDocumentoIdentita) {
      var provincia = '';
      if (!isDocumentoIdentita) {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;
      } else {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice;
      }

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        if (!self.isDocumentoIdentita) {
          self.comuni = [];
        } else {
          self.comuniEnteRilascio = [];
        }
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        if (!isDocumentoIdentita) {
          self.comuni = domain;
        } else {
          self.comuniEnteRilascio = domain;
        }
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        if (self.$stateParams.idProdotto) {
          self.idProdotto = self.$stateParams.idProdotto;
        }

        if (self.propostaCartaDebitoIntSrvc.datiPratica) {
          // Recupero specializzazione
          self.specializzazione = self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione;

          // Visualizzazione riepilogo
          if (
            self.propostaCartaDebitoIntSrvc.datiPratica.prodotto &&
            self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.descrizione
          ) {
            self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;
            self.tipoProdotto = self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.descrizione;
          }

          // Caricamento conti corrente
          if (
            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER
          ) {
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
              ndgUtilizzatore: null,
              numeroRapporto: null,
              iban: null,
              tipoCarta: null
            };
          }
        }

        self.recuperaAnagrafica();
        if (
          self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
          self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER
        ) {
          self.recuperaListaNdg();
        }
      });
    };
    self.init();
  };

  CdintDefinizioneCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDefinizione/cdintDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDefinizioneComponent = {
    controller: CdintDefinizioneCtrl,
    controllerAs: 'cdintDefinizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDefinizione', CdintDefinizioneComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintDefinizione/cdintDefinizione.cmpt.js
// module id = 8
// module chunks = 0